import type { CandidateHistoryQueryData } from 'shared/legacy/hooks/useCandidateHistoryQuery.types';

import { queryClient } from 'config/queryClient';
import { CandidateHistoryAction } from 'services/candidates/types';
import { QueryKey } from 'types/query';

export type IndeedConversation = {
  conversationId: string;
  jobSeekerKey: string;
};

const INDEED_MESSAGE_ACTIONS = [CandidateHistoryAction.IndeedSent, CandidateHistoryAction.IndeedReceived];

export const findIndeedConversationInHistory = (
  esPersonId: string,
  licenseEmailAddress: string | null,
): IndeedConversation | null => {
  if (!licenseEmailAddress) return null;

  const history = queryClient
    .getQueriesData<CandidateHistoryQueryData>([QueryKey.useCandidateHistoryQuery, { candidateEsPersonId: esPersonId }])
    .flatMap(([, queryData]) => queryData?.data ?? []);

  const [mostRecent] = history
    .filter(
      (entry) =>
        INDEED_MESSAGE_ACTIONS.includes(entry.action) &&
        entry.metadata?.license_email_address === licenseEmailAddress &&
        !!entry.metadata?.conversation_id &&
        !!entry.metadata?.job_seeker_key,
    )
    .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

  if (!mostRecent?.metadata) return null;

  return {
    conversationId: mostRecent.metadata.conversation_id,
    jobSeekerKey: mostRecent.metadata.job_seeker_key,
  };
};
